import AppFormContainer from '@nxsys/components/AppFormContainer';
import { StyledAppSelect } from '@nxsys/components/AppSelect/index.styled';
import { Form } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import StepCard from './StepCard';
import { regulationOptions } from '@nxsys/constants/AppConstants';

interface AddAgencyConductRegulationProps {
  stepNumber: number;
  agencyConductRegulation?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddAgencyConductRegulationValues = {
  agencyConductRegulationValue: string;
};

const AddAgencyConductRegulation: React.FC<AddAgencyConductRegulationProps> = ({
  stepNumber,
  agencyConductRegulation,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddAgencyConductRegulationValues>();
  const { messages } = useIntl();

  const onFinish = (values: AddAgencyConductRegulationValues) => {
    const params = {
      agencyConductRegulation: values?.agencyConductRegulationValue ?? null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addAgencyConductRegulation'] as string}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          agencyConductRegulationValue: agencyConductRegulation ?? undefined,
        }}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['prospect.onboarding.agencyConductRegulation'] as string}
          name="agencyConductRegulationValue"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'] as string,
            },
          ]}
        >
          <StyledAppSelect
            options={regulationOptions}
            placeholder={
              messages['prospect.onboarding.agencyConductRegulation.placeholder'] as string
            }
            showSearch
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddAgencyConductRegulation;
